import React from 'react';
import PropTypes from 'prop-types';
import FBPNAutocompleteDisplay from './FBPNAutocompleteDisplay';

class FBPNAutocompleteContainer extends React.Component {
  static propTypes = {
    loadSuggestions: PropTypes.func.isRequired,
    clearSuggestions: PropTypes.func.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    isLoadingSuggestions: PropTypes.bool,
    suggestions: PropTypes.array,
    onNewItem: PropTypes.func.isRequired,
  };

  static defaultProps = {
    value: undefined,
    isLoadingSuggestions: undefined,
    suggestions: undefined,
  }

  handleChange = (newValue) => {
    this.props.onChange(newValue);
  }

  handleNewItem = (newValue) => {
    this.props.onNewItem(newValue);
  };

  loadSuggestions = (searchValue) => {
    const val = searchValue.toLowerCase();
    this.props.loadSuggestions(val);
  }

  render() {
    return (
      <FBPNAutocompleteDisplay
        suggestions={ this.props.suggestions }
        isLoadingSuggestions={ this.props.isLoadingSuggestions }
        value={ this.props.value }
        onChange={ this.handleChange }
        onNewItem={ this.handleNewItem }
        loadSuggestions={ this.loadSuggestions }
        clearSuggestions={ this.props.clearSuggestions }
      />
    );
  }
}

export default FBPNAutocompleteContainer;
